module.exports = __webpack_public_path__ + "img/icon.ee4a096c.png";